import React, { useState } from "react";
import { Button, Dialog, Classes, Intent, Checkbox } from "@blueprintjs/core";
import naturalCompare from "natural-compare";

export function CompanyLinkChangeButton({
  company,
  accountingCompanies,
  updateLink,
  system
}) {
  const [changing, setChanging] = useState(false);
  return (
    <>
      <Button
        className="bp3-button bp3-small"
        onClick={() => setChanging(true)}
      >
        Change
      </Button>
      {changing && (
        <CompanyChangeLinkDialog
          company={company}
          onClose={() => setChanging(false)}
          accountingCompanies={accountingCompanies}
          updateLink={updateLink}
          system={system}
        />
      )}
    </>
  );
}

function CompanyChangeLinkDialog({
  company,
  onClose,
  accountingCompanies,
  updateLink,
  system
}) {
  const [billId, setBillId] = useState(company.billAccountingCompanyId);
  const [saleId, setSaleId] = useState(company.saleAccountingCompanyId);
  const [billedSeparately, setBilledSeparately] = useState(
    Boolean(company.billedSeparately)
  );
  return (
    <Dialog
      isOpen={true}
      title={`Change '${company.name}' MYOB Link`}
      onClose={onClose}
    >
      <div className={Classes.DIALOG_BODY}>
        <p>Please select a MYOB company to send bills to:</p>
        <p className="bp3-small">For example, airtime invoice, data pack etc.</p>
        <p>
          <div className="bp3-select bp3-fill bp3-large">
            <select
              onChange={(e) => setBillId(e.target.value)}
              defaultValue={company.billAccountingCompanyId}
            >
              <option value="">None</option>
              {Object.values(accountingCompanies)
                .sort((a, b) =>
                  naturalCompare(a.name.toLowerCase(), b.name.toLowerCase())
                )
                .filter((item) => {
                  if (system === undefined || !system.includes('globe')) {
                    return true;
                  }
                  return (system.includes('globe') && item.companyId.split("::")[0].includes(system))
                })
                .map((item) => (
                  <option key={item.companyId} value={item.companyId}>{`${
                    item.name
                  } (${item.companyId.split("::")[0]}) - ${item.status}`}</option>
                ))}
            </select>
          </div>
        </p>
        {company.companyId.match(/-bureau-/) && (
          <p>
            <Checkbox
              checked={billedSeparately}
              onChange={(e) => setBilledSeparately(e.target.checked)}
              label="Bill Bureau Directly"
            />
          </p>
        )}
        <p>Please select a MYOB company to link hardware sales to (e.g. PM 45s):</p>
        <p>
          <div className="bp3-select bp3-fill bp3-large">
            <select
              onChange={(e) => setSaleId(e.target.value)}
              defaultValue={company.saleAccountingCompanyId}
            >
              <option value="">None</option>
              {Object.values(accountingCompanies)
                .sort((a, b) =>
                  naturalCompare(a.name.toLowerCase(), b.name.toLowerCase())
                )
                .filter((item) => {
                  if (system === undefined || !system.includes('globe')) {
                    return true;
                  }
                  return (system.includes('globe') && item.companyId.split("::")[0].includes(system))
                })
                .map((item) => (
                    <option key={item.companyId} value={item.companyId}>{`${
                        item.name
                    } (${item.companyId.split("::")[0]}) - ${item.status}`}</option>
                ))}
            </select>
          </div>
        </p>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            intent={Intent.PRIMARY}
            onClick={async () => {
              await updateLink(
                company.system,
                company.companyId,
                billId || "",
                saleId || "",
                billedSeparately
              );
              onClose();
            }}
          >
            Change
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
